import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { ZypeService } from 'src/app/core/services/zype.service';
import { lastValueFrom } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'app-create-application',
  templateUrl: './create-application.component.html',
  styleUrl: './create-application.component.scss'
})
export class CreateApplicationComponent implements OnInit {

  constructor(
    private zypeService: ZypeService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.createApplicationProcess();
  }

  async createApplicationProcess() {
    this.spinner.show();
    try {

      const appRes = await lastValueFrom(this.zypeService.createApplication());

      this.spinner.hide();

      if (appRes.error) {
        swal.fire('Error', appRes.error, 'error');
        return;
      }

      // Handle success
      if (appRes.data && appRes.data.redirectUrl) {
        window.location.href = appRes.data.redirectUrl;
      } else if (appRes.data) {
        // Fallback if there's no redirectUrl but successful
        swal.fire('Success', 'Application created successfully, but no redirect URL was returned.', 'success');
      }

    } catch (error: any) {
      console.error(error);
      this.spinner.hide();
      swal.fire('Error', 'An unexpected error occurred. Please try again.', 'error');
    }
  }
}
